export default __webpack_public_path__ + "static/media/nogoogle.690df44f.svg";